import {User} from "@iw-shared/users/models/user";

export interface UserState extends Partial<User> {

  isLoading?: boolean;
}

export const initialUserState = (): UserState => {
  return {};
};
